import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { Popover, PopoverTrigger, PopoverContent } from '@anyroad/popover';
import { Icon } from '@anyroad/icon';
import { colors } from '@anyroad/theme';
import { Row, LeftColumn, RightColumn, BookingFeeContainer } from './styles';

interface BookingFeeProps {
  includesBookingFee: boolean;
  bookingFeeFormatted: string;
}

const HelpIcon = styled(Icon)`
  display: inline-block;
  margin-left: 4px;
  cursor: pointer;
  vertical-align: middle;
  width: 16px;
  height: 16px;
`;

const PopoverContentStyled = styled.div`
  background: white;
  border: 1px solid ${colors.border};
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 250px;
  font-size: 14px;
  color: ${colors.text.primary};
`;

export const BookingFee = ({
  includesBookingFee,
  bookingFeeFormatted,
}: BookingFeeProps) => {
  if (!includesBookingFee) {
    return null;
  }
  return (
    <Row className="two column row">
      <LeftColumn className="left aligned column">
        <BookingFeeContainer>
          <span role="button" tabIndex={0} className="dotted">
            <FormattedMessage defaultMessage="Service fee" />
          </span>
          <Popover placement="top">
            <PopoverTrigger asChild>
              <HelpIcon name="TooltipQuestionMark" />
            </PopoverTrigger>
            <PopoverContent>
              <PopoverContentStyled>
                <FormattedMessage defaultMessage="Includes credit card processing and service provider fees" />
              </PopoverContentStyled>
            </PopoverContent>
          </Popover>
        </BookingFeeContainer>
      </LeftColumn>
      <RightColumn className="column" data-testid="service-fee">
        {bookingFeeFormatted}
      </RightColumn>
    </Row>
  );
};
